// Converts a bracket-notation query string (filter[sender][]=42) into a nested object
// ({ filter: { sender: ["42"] } }), which jQuery's $.param() re-serializes back into the same
// form. A URLSearchParams rewrite would lose the nesting.
//
// Split out of campaign_update_controller.js (its only caller) as a pure function -- it takes a
// string and returns an object, with no dependency on `this` or any controller state.
export default function urlParamsAsObject(dataSource) {
  const query = dataSource.substring(dataSource.indexOf("?") + 1)
  const regex = /([^&=]+)=?([^&]*)/g
  const decode = (str) => decodeURIComponent(str.replace(/\+/g, " "))

  const params = {}
  let match = regex.exec(query)
  while (match) {
    const k = decode(match[1])
    const v = decode(match[2])

    if (k.substring(k.length - 2) === "[]") {
      const key = k.substring(0, k.length - 2)
      ;(params[key] || (params[key] = [])).push(v)
    } else {
      params[k] = v
    }

    match = regex.exec(query)
  }

  const assignPath = (obj, keyPath, value) => {
    const lastKeyIndex = keyPath.length - 1
    let target = obj
    for (let i = 0; i < lastKeyIndex; i++) {
      const key = keyPath[i]
      if (!(key in target)) { target[key] = {} }
      target = target[key]
    }
    target[keyPath[lastKeyIndex]] = value
  }

  Object.keys(params).forEach((prop) => {
    const structure = prop.split("[")
    if (structure.length > 1) {
      const levels = structure.map((part) => part.replace(/[?[\]\\ ]/g, ""))
      assignPath(params, levels, params[prop])
      delete params[prop]
    }
  })

  return params
}
